import status from "../../util/requestStatuses";

export default {
  [status.review]: {
    title: "Review Your Request",
    action: "Submit",
    secondary: "Go Back"
  },
  [status.pending]: {
    title: "Sending request"
  },
  [status.success]: {
    title: "Success",
    description: `Your request has been added to our list. You should receive a confirmation e-mail shortly with details about your request. If we have any questions, we'll be in touch.`,
    action: "Done",
    secondary: "Make another request"
  },
  [status.error]: {
    title: "Error",
    description: "There was a problem submitting your request.",
    action: "Resubmit",
    secondary: "Go Back"
  }
};



// WEBPACK FOOTER //
// ./src/Video/config/modalMessages.js